export default "__VITE_ASSET__Dva6H2s1__"